import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import GamePage from './pages/GamePage';
import LeaderboardPage from './pages/LeaderboardPage';
import CommunityStatsPage from './pages/CommunityStatsPage';
import LegalInfoPage from './pages/LegalInfoPage';
import AboutPage from './pages/AboutPage';
import ResetPage from './pages/ResetPage';
import AvatarPreviewPage from './pages/AvatarPreviewPage';
import FinalAvatarSelectionPage from './components/FinalAvatarSelection';
import AvatarSelectionPage from './pages/AvatarSelectionPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import ContactPage from './pages/ContactPage';
import FAQPage from './pages/FAQPage';
import HowToPlayPage from './pages/HowToPlayPage';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import AdvertisePage from './pages/AdvertisePage';
import RTAPage from './pages/RTAPage';
import AdsAnalyticsPage from './pages/AdsAnalyticsPage';
import useGameStore from './store/gameStore';
import { Toaster } from './components/ui/toaster';
import './App.css';

// Global presence heartbeat for Real-Time Analytics
function PresenceTracker() {
  const location = useLocation();
  useEffect(() => {
    let sessionId = localStorage.getItem('jb_session_id');
    if (!sessionId) {
      sessionId = 'sess_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
      localStorage.setItem('jb_session_id', sessionId);
    }
    const ping = () => {
      try {
        fetch(`${process.env.REACT_APP_BACKEND_URL}/api/analytics/heartbeat`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          keepalive: true,
          body: JSON.stringify({
            session_id: sessionId,
            nickname: localStorage.getItem('jailbirds_nickname') || null,
            page: window.location.pathname,
          }),
        }).catch(() => {});
      } catch (e) { /* noop */ }
    };
    ping();
    const interval = setInterval(ping, 30000);
    return () => clearInterval(interval);
  }, [location.pathname]);
  return null;
}

function App() {
  const { setNickname, setAvatarId } = useGameStore();

  useEffect(() => {
    // Check if user has a nickname and avatar in localStorage and load them
    const storedNickname = localStorage.getItem('jailbirds_nickname');
    const storedAvatarId = localStorage.getItem('jailbirds_avatar_id');
    
    if (storedNickname) {
      setNickname(storedNickname);
    }
    
    if (storedAvatarId) {
      setAvatarId(parseInt(storedAvatarId, 10));
    }
  }, [setNickname, setAvatarId]);

  return (
    <Router>
      <div className="min-h-screen bg-background">
        <PresenceTracker />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/game" element={<GamePage />} />
          <Route path="/leaderboard" element={<LeaderboardPage />} />
          <Route path="/community-stats" element={<CommunityStatsPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/legal" element={<LegalInfoPage />} />
          <Route path="/reset" element={<ResetPage />} />
          <Route path="/avatar-preview" element={<AvatarPreviewPage />} />
          <Route path="/final-avatars" element={<FinalAvatarSelectionPage />} />
          <Route path="/select-avatars" element={<AvatarSelectionPage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsOfServicePage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/how-to-play" element={<HowToPlayPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/ads" element={<AdvertisePage />} />
          <Route path="/rta" element={<RTAPage />} />
          <Route path="/ads-analytics" element={<AdsAnalyticsPage />} />
        </Routes>
        <Toaster />
      </div>
    </Router>
  );
}

export default App;
